/**
 * ------------------------------------------------------------------------------------------------------------
 * ARCHITECTURAL NOTE:
 * KHÔNG sử dụng file index.ts (Barrel) trong thư mục @core để tránh Circular Dependency (NG0200).
 * Luôn import trực tiếp từ file nguồn.
 * ------------------------------------------------------------------------------------------------------------
 */
import {Inject, Injectable, PLATFORM_ID} from "@angular/core";
import {AppService} from "@core/services/app.service";
import {LocalStorageService} from "@core/services/storage.service";
import {CookiePosService} from "@core/services/cookie-pos.service";
import {UserSpecificService} from "@shared/services/feature-specific/user-specific.service";
import {STORAGE_KEY, STORAGE_SETTING_UI} from "@core/constants";
import {isLoginEd} from "@core/utils";
import {castInt} from "@shared/utils";
import {UI_CONSTS} from "@shared/constants";
import {isPlatformBrowser} from "@angular/common";
import {Ibreadcrumb, IProfileUI} from '@core/models';


/**
 * Service xử lý toàn bộ các cài đặt chung liên quan đến UI
 *
 * @author admin
 * */
@Injectable({
  providedIn: 'root'
})
export class AppLayoutService {
  profileUI: IProfileUI = {
    sidebarResize: 0,
    color: 1,
    menu: UI_CONSTS.UI_LAYOUT_MENU_HORIZONTAL,
    // menu: UI_CONSTS.UI_LAYOUT_MENU_VERTICAL
  }
  classWrapper: string = ''; // Class layout wrapper dùng để tùy chỉnh css khi cần css là global

  classWrapperContent = ''; // Class giới hạn độ rộng hiển thị nội dung

  breadcrumbs: Ibreadcrumb[] = [];
  screenWidth!: number;
  isOpenNavMobile = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private _app: AppService,
    public store: LocalStorageService,
    public userSpecificService: UserSpecificService,
    private _cookieService: CookiePosService,
  ) {
    this.handleInit();
  }

  private handleInit() {
    this.loadConfigUI();

    const wrapperContent = this.store.get(STORAGE_SETTING_UI.posWrapperHorizontal);
    this.classWrapperContent = wrapperContent ? wrapperContent : 'pos-wrapper-horizontal-100';

    if (isPlatformBrowser(this.platformId)) {
      this.screenWidth = window.innerWidth;
      window.addEventListener('resize', () => {
        this.screenWidth = window.innerWidth;
      });
    }
  }

  loadConfigUI() {
    const storageUI = this.getStorageUI();
    if (storageUI) {
      // tạm bỏ do chưa có setting ui
      return this.setProfileUI(storageUI)
    }

    if (!isLoginEd(this._app, this._cookieService)) {
      return;
    }
    this.userSpecificService.loadProfileUI().subscribe({
      next: res => {
        if (!res.code) {
          this.profileUI['color'] = UI_CONSTS.UI_LAYOUT_COLOR_RED;
          // this.profileUI['menu'] = UI_CONSTS.UI_LAYOUT_MENU_HORIZONTAL;
          this.profileUI['menu'] = UI_CONSTS.UI_LAYOUT_MENU_VERTICAL;
          this.profileUI['sidebarResize'] = UI_CONSTS.UI_LAYOUT_SIDEBAR_RESIZE_NO;
        } else {
          this.setProfileUI(res.data)
        }
        this.saveStorageUI()
      }
    });
  }

  private setProfileUI(data: { color: number, menu: number, sidebarResize: number }) {
    const {color, menu, sidebarResize} = data;

    this.profileUI['color'] = color ? castInt(color) : UI_CONSTS.UI_LAYOUT_COLOR_RED;
    this.profileUI['menu'] = menu ? castInt(menu) : UI_CONSTS.UI_LAYOUT_MENU_HORIZONTAL;
    this.profileUI['sidebarResize'] = sidebarResize ? castInt(sidebarResize) : UI_CONSTS.UI_LAYOUT_SIDEBAR_RESIZE_NO;
  }


  // Lưu vào storage
  private saveStorageUI() {
    this.store.set(STORAGE_KEY.profileUI, this.profileUI)
  }

  private getStorageUI(): IProfileUI | null {
    const UI = this.store.get(STORAGE_KEY.profileUI);
    if (!UI || typeof UI != "object" || !Object.keys(UI).length) {
      return null;
    }
    return UI;
  }

  // change class for body dùng style menu ngang
  setClassBody() {
    let classBodyName = '';
    if (this.profileUI['menu'] == UI_CONSTS.UI_LAYOUT_MENU_HORIZONTAL) {
      classBodyName = 'body-menu-horizontal'
    }

    if (isPlatformBrowser(this.platformId)) {
      const bodyElement = document.body;
      bodyElement.className = '';
      bodyElement.className = classBodyName;
    }
  }
}
